import { render, staticRenderFns } from "./EventDialog.vue?vue&type=template&id=374d96f5&scoped=true"
import script from "./EventDialog.vue?vue&type=script&lang=js"
export * from "./EventDialog.vue?vue&type=script&lang=js"
import style0 from "./EventDialog.vue?vue&type=style&index=0&id=374d96f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374d96f5",
  null
  
)

export default component.exports